import { atom } from 'recoil';

export const noteTypesData = atom({
  key: "noteTypesData",
  default: null
});